import { hbs } from 'ember-cli-htmlbars';
import { ActionCreator } from '@banking/ui/workflows/balance';
import { workflowComponent } from '@banking/ui/services/unit-balance';
const mapStateToProps = state => ({
  wasWaitlistClicked: state.wasWaitlistClicked
});
const mapActionsToProps = () => ({
  onUploadBillClick: () => ActionCreator.userClickUploadBill(),
  onWaitlistClick: () => ActionCreator.userClickWaitlist()
});
const template = hbs`
  <Banking::BillPay::Help::BillPay
    @onUploadBillClick={{this.onUploadBillClick}}
    @onWaitlistClick={{this.onWaitlistClick}}
    @wasWaitlistClicked={{this.wasWaitlistClicked}}
  />
`;
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);